import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wzx8v3srb4: FaireBrandEntity = {
  token: "b_wzx8v3srb4",
  type: "brand",
  name: "Algae Cooking Club",
  avatarUrl:
    "https://cdn.faire.com/fastly/abc6b0928ec23675f1c0da8c776f8ba9b85974369dc2b9c3d5f20ecd7aed04a5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e6283507454c66ecb8247e64d64299c3903c10f00176a0404fbc4c82583122ce.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/abc6b0928ec23675f1c0da8c776f8ba9b85974369dc2b9c3d5f20ecd7aed04a5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e6283507454c66ecb8247e64d64299c3903c10f00176a0404fbc4c82583122ce.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 60,
  rating: 5,
  reviewCount: 35,
  isTopShop: true,
  isInsider: true,
  description:
    "At Algae Cooking Club, we’re rewriting the future of cooking oil. Our chef-grade algae oil is a game-changer: a supremely versatile, clean, and neutral oil that outperforms traditional options like avocado and olive oil. With the highest smoke point of any oil and the highest composition of heart-healthy Omega-9s, it’s the choice of world-class chefs and nutritionists alike.\n\nOur lineup includes pure algae cooking oil and infused creations like Gochugaru Chili Oil and Shiitake Mushroom Oil, developed in collaboration with Chef Daniel Humm of Eleven Madison Park. More than just oil, we’re a movement—pushing the boundaries of flavor, sustainability, and performance in the kitchen. Join the club and bring the future of cooking to your shelves.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:47.380Z",
    importedBy: "entity-db-cli",
  },
};
